import Errormsg from "@frameworks/shared-library/components/errorMsg";
import React from "react";
import emptyFolder from "@frameworks/shared-library/assets/images/markets/emptyFolder.svg";
var ErrorOrComingSoon = function () {
    return (React.createElement(Errormsg, { image: emptyFolder, msg: " ", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
            React.createElement("p", { className: "DMSanN_18_400 txt_blackOne1" }, " Coming Soon!")) }));
};
export default ErrorOrComingSoon;
